import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import { EUI_FORM_MAX_WIDTH } from 'components/euiParity'
import { SearchBarProps } from './types'
import useSearchInput from './useSearchInput'

export default function SearchBarMui( props: SearchBarProps ) {
	const { inputVal, setInputVal } = useSearchInput( props )

	return (
		<TextField
			value={inputVal ?? ''}
			onChange={( e ) => setInputVal( e.target.value )}
			placeholder={props.placeholder ?? 'Search'}
			sx={{ width: '100%', maxWidth: EUI_FORM_MAX_WIDTH }}
			slotProps={{
				// Not `type="search"`: WebKit's native cancel button would duplicate the clear adornment.
				htmlInput: { role: 'searchbox' },
				input: {
					startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment>,
					endAdornment: inputVal ? (
						<InputAdornment position="end">
							<IconButton aria-label="Clear search input" edge="end" size="small" onClick={() => setInputVal( '' )}>
								<CloseIcon fontSize="small" />
							</IconButton>
						</InputAdornment>
					) : undefined,
				},
			}}
		/>
	)
}
